import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import { useValue } from '@morningtrain/react-resources'

function UserShiftLabel () {
  const week = useValue('key')

  return (
    <span><Translation name='generic.week_number' data={{ week: week }} /></span>
  )
}

export default UserShiftLabel
